export default {
  title: 'Indstillinger',
  reservation_hours_helper: 'Disse tider bestemmer, hvornår gæster kan reservere online.',
  reservation_hours_alert:
    'Dine reservationstider afviger fra dine almindelige åbningstider. Gæster kan kun booke i de tider, der er angivet her.',
  activated: 'Reservationer aktive',
  deactivated: 'Reservationer inaktive',
  buttons: {
    activate: 'Aktiver',
    deactivate: 'Deaktiver',
  },
  error_messages: {
    no_google_place: {
      title: 'Restauranten er ikke forbundet med nogen Google-lokation',
      description: 'Forbind restauranten med en Google-lokation',
    },
    toggle_failed: 'Reservationer kunne ikke opdateres. Prøv igen.',
  },
};
